import Model, { attr, belongsTo } from '@ember-data/model';
import type Questionnaire from 'garaje/models/questionnaire';
import type QuestionnaireField from 'garaje/models/questionnaire-field';
import type { LocaleKey } from 'garaje/utils/locale-options';
import { createLocalizedProxy, type CustomTranslations } from 'garaje/utils/translations';
import { TrackedObject } from 'tracked-built-ins';

const TRANSLATABLE_ATTRIBUTES = ['value'] as const;
type TranslatableAttributes = (typeof TRANSLATABLE_ATTRIBUTES)[number];

export default class QuestionnaireFieldOption extends Model {
  @belongsTo('questionnaire', { async: false, inverse: null })
  declare questionnaire: Questionnaire;

  @belongsTo('questionnaire-field', { async: false, inverse: 'questionnaireFieldOptions' })
  declare questionnaireField: QuestionnaireField;

  @attr('deeply-tracked-object', { defaultValue: () => new TrackedObject() })
  declare customTranslations: CustomTranslations<TranslatableAttributes>;

  @attr('boolean') declare isCorrect: boolean;
  @attr('number') declare position: number;
  @attr('string') declare value: string;

  forLocale(selectedLocale: LocaleKey, defaultLocale: LocaleKey): this {
    if (selectedLocale !== defaultLocale) {
      return createLocalizedProxy(this, <string[]>(<unknown>TRANSLATABLE_ATTRIBUTES), selectedLocale);
    }
    return this;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'questionnaire-field-option': QuestionnaireFieldOption;
  }
}
